<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="link-checkbox-inner" :class="classes">
		<polyline points="25,50 45,70 75,25" v-if="status === 'check'" class="link-checkbox-inner-check-polyline"/>
		<line x1="20" y1="50" x2="80" y2="50" v-if="status === 'minus'" class="link-checkbox-inner-minus-polyline"/>
	</svg>
</template>

<script>
	export default {
		name: "link-checkbox-inner",
		props: {
			disabled: {type: Boolean},
			status: {default: 'check'},                             // check,uncheck,minus
		},
		computed: {
			classes() {
				return [
					`link-checkbox-inner-status-${this.status}`,
					{
						'link-checkbox-inner-disabled': this.disabled,
					}
				]
			},
		},
	}
</script>

<style lang="scss">
	@include themeify {
		.link-checkbox-inner {
			width: 1em;
			height: 1em;

			display: inline-block;
			box-sizing: border-box;
			vertical-align: middle;
			background-color: white;
			border-radius: 1px;
			border: solid 1px currentColor;

			&.link-checkbox-inner-status-check {

				background-color: currentColor;
				border-color: currentColor;

				.link-checkbox-inner-check-polyline {
					fill: transparent;
					stroke: white;
					stroke-width: 10;
				}
			}

			&.link-checkbox-inner-status-uncheck {
				background-color: white;
			}

			&.link-checkbox-inner-status-minus {
				background-color: currentColor;

				.link-checkbox-inner-minus-polyline {
					fill: currentColor;
					stroke: white;
					stroke-width: 13
				}
			}

			&.link-checkbox-inner-disabled {
				&.link-checkbox-inner-status-check {
					.link-checkbox-inner-check-polyline {
						stroke: currentColor;
					}
				}

				&.link-checkbox-inner-status-minus {
					.link-checkbox-inner-minus-polyline {
						stroke: currentColor;
					}
				}

			}
		}
	}
</style>